// @flow
// /* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */

import ImageSource from "../../source/image_source";
import { beginGeojsonStencil } from "./stencil_mode";
// import StencilMode from "../../gl/stencil_mode";
import DepthMode from "../../gl/depth_mode";
import ColorMode from "../../gl/color_mode";
import VertexArrayObject from '../../render/vertex_array_object';

import type Painter from "../../render/painter";
import type SourceCache from "../../source/source_cache";
import type { OverscaledTileID } from "../../source/tile_id";


export default drawSencilImg;
// StencilMode.stencilImg = new StencilMode({ func: 'GEQUAL', mask: 0xFF }, 1, 0xFF, 'KEEP', 'KEEP', 'INCR');
// StencilMode.drawWithStencil = new StencilMode({ func: 'EQUAL', mask: 0xFF }, 1, 0x00, 'KEEP', 'KEEP', 'REPLACE');


function drawSencilImg(
    painter: Painter,
    sourceCache: SourceCache,
    coord: OverscaledTileID,
    parentProgram: string,
    layer,
) {
    // return;
    // const context = painter.context;
    // const gl = context.gl;
    const source = sourceCache.getSource();
    const program = painter.useProgram("stencil-img");
    // context.setStencilMode(beginGeojsonStencil);
    // context.depthTest.set(false);
    // gl.clear(gl.STENCIL_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
    // context.colorMask.set([true, true, true, true]);

    // gl.uniform1i(program.uniforms.uSampler, 7);
    // const posMatrix = painter.transform.calculatePosMatrix(
    //     coord.toUnwrapped(),
    //     true,
    // );
    // gl.uniformMatrix4fv(program.uniforms.u_matrix, false, posMatrix);
    // context.activeTexture.set(gl.TEXTURE7);
    // gl.bindTexture(gl.TEXTURE_2D, source.geojsonTexture);

    if (source instanceof ImageSource) {
        // const buffer = source.boundsBuffer;
        // const vao = source.boundsVAO;
        const layerID = layer.id;
        // vao.bind(context, program, buffer, []);
        // gl.drawArrays(gl.TRIANGLE_STRIP, 0, buffer.length);
        drawMaskImg(painter, program, coord, source, layerID);
    }
    painter.useProgram(parentProgram);
}

function drawMaskImg(painter, program, coord, source, layerID) {
    const context = painter.context;
    const gl = context.gl;
    const layoutVertexBuffer = source.boundsBuffer;
    const indexBuffer = painter.quadTriangleIndexBuffer;
    const segments = source.boundsSegments;
    const primitiveSize = 3;

    context.program.set(program.program);
    context.setDepthMode(DepthMode.disabled);
    context.setStencilMode(beginGeojsonStencil);
    context.setColorMode(ColorMode.disabled);

    // for (const name in program.fixedUniforms) {
    //     this.fixedUniforms[name].set(uniformValues[name]);
    // }
    gl.uniform1i(program.uniforms.uSampler, 7);
    const posMatrix = painter.transform.calculatePosMatrix(
        coord.toUnwrapped(),
        true,
    );
    gl.uniformMatrix4fv(program.uniforms.u_matrix, false, posMatrix);
    context.activeTexture.set(gl.TEXTURE7);
    gl.bindTexture(gl.TEXTURE_2D, source.geojsonTexture);

    for (const segment of segments.get()) {
        const vaos = segment.vaos || (segment.vaos = {});
        const vao: VertexArrayObject =
            vaos[layerID] || (vaos[layerID] = new VertexArrayObject());

        vao.bind(
            context,
            program,
            layoutVertexBuffer,
            [],
            indexBuffer,
            segment.vertexOffset,
        );

        gl.drawElements(
            gl.TRIANGLES,
            segment.primitiveLength * primitiveSize,
            gl.UNSIGNED_SHORT,
            segment.primitiveOffset * primitiveSize * 2,
        );
    }
}
